import React from "react";
import check from "../../assets/images/check.svg";
import { closePopup } from "../../features/slices/ModalSlice";
import { useDispatch } from "react-redux";
import { updateSelectedItem } from "../../features/slices/CommonSlice";

export default function CompletionPopup() {
  const dispatch = useDispatch();

  const closeCompletionPopup = () => {
    dispatch(closePopup());
    dispatch(updateSelectedItem(null));
  };

  return (
    <div
      className="modal fade otp--modal mpin-setup-prompt show"
      style={{
        display: "block",
        backdropFilter: "blur(15px)",
        background: "rgb(70, 70, 70, 0.6)",
      }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h2 className="modal-title fs-5" />
            <i
              data-bs-dismiss="modal"
              aria-label="Close"
              className="bi bi-x-lg"
              onClick={closeCompletionPopup}
            />
          </div>
          <div className="modal-body mpin-setup-prompt__body text-center">
            <img
              loading="lazy"
              src={check}
              alt="Mobile verification done"
              width={72}
              height={72}
            />
            <p className="mpin-setup-prompt__title mt-3">
              Mobile verification is done
            </p>
            <div className="mpin-setup-prompt__actions">
              <button
                type="button"
                className="mpin-setup-prompt__yes-btn"
                onClick={closeCompletionPopup}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
